/* eslint-disable */
import axios from 'axios';

const BASE_API = 'https://floral-shape-fb3e.flm60008.workers.dev/api';

export interface ReturnData {
  status: string;
  data?: unknown | unknown[];
}

export interface ResponseStore {
  id: number;
  storeStatus: string;
  netTicketStatus: string;
  name: string;
  address: string;
  area: string;
  latitude: number;
  longitude: number;
  wait: number;
  queue: number[];
}

export class Store {
  id: number;
  storeStatus: string;
  netTicketStatus: string;
  name: string;
  address: string;
  area: string;
  location: number[];
  wait: number;
  queue: number[];
  isBookmark: boolean;
  latitude?: number;
  longitude?: number;

  constructor(
    id: number,
    storeStatus: string,
    netTicketStatus: string,
    wait: number,
    name: string,
    address: string,
    area: string,
    latitude: number,
    longitude: number
  ) {
    this.id = id;
    this.storeStatus = storeStatus;
    this.netTicketStatus = netTicketStatus;
    this.name = name;
    this.address = address;
    this.area = area;
    this.location = [latitude, longitude];
    this.wait = wait;
    this.queue = [];
    this.isBookmark = false;
  }

  async getQueue(): Promise<void> {
    try {
      const response = await axios.get(`${BASE_API}/queue?storeid=${this.id}`);
      this.queue = response.data.storeQueue;
    } catch (err) {
      console.error(err);
    }
  }
}

export interface Queue {
  storeId: number;
  data: number[];
}